import { render, staticRenderFns } from "./UnderReview.vue?vue&type=template&id=2b5d2b7a&scoped=true&"
import script from "./UnderReview.vue?vue&type=script&lang=js&"
export * from "./UnderReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5d2b7a",
  null
  
)

export default component.exports